import React from 'react';
import Devices from '@personal/devices';

const HomePage = () => {
  return <Devices />;
};
export default HomePage;
